import React from 'react'
import { name } from './data'

export default function Name() {
    return (
        <div>{name}</div>
    )
}
